import React, { FunctionComponent } from "react";
import { useParams } from "wouter";

import { Accessories } from "../blocks/Accessories/Accessories";
import { Meta } from "../blocks/Meta/Meta";
import { NotFound } from "../blocks/NotFound/NotFound";
import { Packages } from "../blocks/Packages/Results/Packages";
import { ProductModal } from "../blocks/ProductDetails/ProductModal";
import { Tires } from "../blocks/Tires/Results/Tires";
import { Wheels } from "../blocks/Wheels/Results/Wheels";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../constants/productTypes";
import {
  DealerPartNumberResultsRoute,
  DealerTiresizeResultsRoute,
} from "../navigation/DealerRoutes";
import { useSomeRoutes } from "../navigation/useSomeRoutes";

const map = {
  [productTypeAccessory]: Accessories,
  [productTypePackage]: Packages,
  [productTypeTire]: Tires,
  [productTypeWheel]: Wheels,
};

export const DealerResultsPage: FunctionComponent = () => {
  const forceTireSizePage = useSomeRoutes(
    DealerTiresizeResultsRoute,
    DealerPartNumberResultsRoute
  );
  const route = useParams();
  const Component = forceTireSizePage
    ? Tires
    : map[route?.productType as keyof typeof map] ?? NotFound;

  return (
    <>
      <Meta cmsTitle={null} title="dealerResultsPage" />
      <Component />
      <ProductModal />
    </>
  );
};
